// extracted by mini-css-extract-plugin
export default {"header":"dcc_equipmentFamiliesTables-header","title":"dcc_equipmentFamiliesTables-title","disclaimer":"dcc_equipmentFamiliesTables-disclaimer"};